import { render, staticRenderFns } from "./seminarios.vue?vue&type=template&id=9b0e33a8"
import script from "./seminarios.vue?vue&type=script&lang=js"
export * from "./seminarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports